module.exports = __webpack_public_path__ + "static/heike-5f739d57611fb193392379892b0490d4.jpg";